export type SftpDateTimeValue = string | number | Date | null | undefined;

export const SFTP_DISPLAY_TIMEZONE = 'Europe/Berlin';

export function getSftpDateTimeLocale(language: string | null | undefined): 'de-DE' | 'en-US' {
  return String(language || '').toLowerCase().startsWith('de') ? 'de-DE' : 'en-US';
}

function toValidDate(value: SftpDateTimeValue): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatSftpDateTime(value: SftpDateTimeValue, language: string | null | undefined): string {
  const date = toValidDate(value);
  if (!date) return '-';

  return new Intl.DateTimeFormat(getSftpDateTimeLocale(language), {
    timeZone: SFTP_DISPLAY_TIMEZONE,
    dateStyle: 'medium',
    timeStyle: 'medium',
  }).format(date);
}
